module.exports = __webpack_public_path__ + "assets/img/lvjiachi_3013_4.1c57a17e.jpg";